// Aca van los objetos que se van a mapear sobre Ejercicios y Musculos que 
// luego se actualizan en la calculadora. Es decir, que si yo elijo Biceps, solo me muestre
// Los ejercicios de Biceps

const aeroex = [
    {   
        id: 0,
        name: 'Sin Aerobico Seleccionado',
        exercises: {
            ex1: 'Selecciona un Ejer Aerobico',
                }
         },
    {   
        id: 1,
        name: 'Saltar Soga',
        exercises: {
            ex1: 'Saltos Simples',
            ex2: 'Saltos Cruzados',
            ex3: 'Saltos Dobles',
            ex4: 'De Todo'
                }
         },
    {   
        id: 2,
        name: 'Cinta',
        exercises: {
            ex1: 'Caminar',
            ex2: 'Caminata con Inclinación',
            ex3: 'Caminata Rápida',
            ex4: 'Trotar',
            ex5: 'Correr',
                }
         },
    {   
        id: 3,
        name: 'Functional',
        exercises: {
            ex1: 'Burpess',
                }
         },
    {   
        id: 4,
        name: 'ABS',
        exercises: {
            ex1: '??',
                }
         },
    {   
        id: 5,
        name: 'Eliptico',
        exercises: {
            ex1: '??',
                }
         },
    {   
        id: 6,
        name: 'Natación',
        exercises: {
            ex1: '??',
                }
         },
    {   
        id: 7,
        name: 'Aire Libre',
        exercises: {
            ex1: 'Correr',
            ex2: 'Caminar',
            ex3: 'Bicicleta',
                }
         },
    {   
        id: 8,
        name: 'Bicicleta Fija',
        exercises: {
            ex1: '??',
                }
         },
    {   
        id: 9,
        name: 'Danza/Zumba',
        exercises: {
            ex1: '??',
                }
         },
]


export default aeroex;